import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { LetterFooter } from '@app/modules/letters/models/letters.model';
import { LettersService } from '@app/modules/letters/services/letters.service';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
import { from, Observable } from 'rxjs';

@Component({
  selector: 'app-letter-footer-dropdown',
  templateUrl: './letter-footer-dropdown.component.html',
  styleUrls: ['./letter-footer-dropdown.component.scss']
})
export class LetterFooterDropdownComponent implements OnInit {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;
  isLoading: boolean;
  user$: any;
  filterString: string;
  options: Observable<PagedData<LetterFooter>>;

  constructor(
    private lettersService: LettersService,
  ) { }

  ngOnInit(): void {
    this.options = from(this.lettersService.getAllLetterFooters(null, `(Status.Id = "PUBLISHED")`))
  }
}
